module.exports = __webpack_public_path__ + "static/media/knihovna.67da9508.jpg";